/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    MarkupEditRequest,
    MarkupEditRequestFromJSON,
    MarkupEditRequestToJSON,
    MarkupPriorityResponse,
    MarkupPriorityResponseFromJSON,
    MarkupPriorityResponseToJSON,
    MarkupRequest,
    MarkupRequestFromJSON,
    MarkupRequestToJSON,
    MarkupResponse,
    MarkupResponseFromJSON,
    MarkupResponseToJSON,
    MarkupTypeResponse,
    MarkupTypeResponseFromJSON,
    MarkupTypeResponseToJSON,
} from '../models';

export interface ApiV2MarkupIdGetRequest {
    id: string;
}

export interface ApiV2MarkupPostRequest {
    markupRequest?: MarkupRequest;
}

export interface ApiV2MarkupPutRequest {
    markupEditRequest?: MarkupEditRequest;
}

/**
 * no description
 */
export class MarkupApi extends runtime.BaseAPI {

    /**
     */
    async apiV2MarkupIdGetRaw(requestParameters: ApiV2MarkupIdGetRequest): Promise<runtime.ApiResponse<MarkupResponse>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiV2MarkupIdGet.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/Markup/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => MarkupResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiV2MarkupIdGet(requestParameters: ApiV2MarkupIdGetRequest): Promise<MarkupResponse> {
        const response = await this.apiV2MarkupIdGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiV2MarkupMarkuptypesGetRaw(): Promise<runtime.ApiResponse<Array<MarkupTypeResponse>>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/Markup/markuptypes`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MarkupTypeResponseFromJSON));
    }

    /**
     */
    async apiV2MarkupMarkuptypesGet(): Promise<Array<MarkupTypeResponse>> {
        const response = await this.apiV2MarkupMarkuptypesGetRaw();
        return await response.value();
    }

    /**
     */
    async apiV2MarkupPostRaw(requestParameters: ApiV2MarkupPostRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/Markup`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MarkupRequestToJSON(requestParameters.markupRequest),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiV2MarkupPost(requestParameters: ApiV2MarkupPostRequest): Promise<void> {
        await this.apiV2MarkupPostRaw(requestParameters);
    }

    /**
     */
    async apiV2MarkupPrioritiesGetRaw(): Promise<runtime.ApiResponse<Array<MarkupPriorityResponse>>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/Markup/priorities`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MarkupPriorityResponseFromJSON));
    }

    /**
     */
    async apiV2MarkupPrioritiesGet(): Promise<Array<MarkupPriorityResponse>> {
        const response = await this.apiV2MarkupPrioritiesGetRaw();
        return await response.value();
    }

    /**
     */
    async apiV2MarkupPutRaw(requestParameters: ApiV2MarkupPutRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v2/Markup`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: MarkupEditRequestToJSON(requestParameters.markupEditRequest),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiV2MarkupPut(requestParameters: ApiV2MarkupPutRequest): Promise<void> {
        await this.apiV2MarkupPutRaw(requestParameters);
    }

}
